const Theme = {
  body_background_color: '#aabc2a',

  logo_image_url: 'promenadeslitteraires.png',
  header_full_height: true,

  button_color: '#4ba7b4',
  button_half_border_color: '#2a275c',
  button_radius: 16,
  button_text_size: 15,

  title_font: `'Arial', sans-serif`,
  text_font: `'Arial', sans-serif`,

  separator_color: '#4DA5B1',

  audio_background_color: '#4DA5B1',
}

export default Theme
